import React from 'react';
import { Button, OptimizedImage } from '../common';
import { useNavigate } from 'react-router-dom';

export const AboutHeroSection: React.FC = () => {
  const navigate = useNavigate();

  const handleLearnMore = () => {
    const missionSection = document.getElementById('mission-section-about');
    if (missionSection) {
      missionSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleContact = () => {
    navigate('/contact');
    window.scrollTo(0, 0);
  };

  return (
    <section className="relative px-4 md:px-16">
      <div className="relative z-10 container mx-auto">
        <div 
          className="flex max-h-[60rem] min-h-[100vh] items-center py-16 md:py-24 lg:py-28"
        >
          <div className="max-w-xl">
            <h1 className="mb-5 text-5xl md:text-7xl lg:text-7xl font-bold font-gabarito text-Color-White leading-tight md:mb-6">
              About Mind<span className="text-[#C97B5A]">Clave</span>
            </h1>
            <p className="text-Color-White text-lg font-cairo md:text-xl mb-8">
              At MindClave, we are dedicated to making AI accessible, practical,
              and beneficial to people from all walks of life. We believe that
              AI should empower individuals and organizations to achieve more,
              not replace human creativity and judgment.
            </p>
            <div className="flex flex-wrap gap-4">
              <Button variant="primary" size="lg" onClick={handleLearnMore}>
                Learn More
              </Button>
              <Button variant="secondary" size="lg" onClick={handleContact}>
                Contact
              </Button>
            </div>
          </div>
        </div>
      </div>
      <div className="absolute inset-0 z-0">
        <OptimizedImage
          src="/images/017.about-hero.jpeg" 
          alt="About MindClave" 
          className="absolute inset-0 w-full h-full"
          priority={true}
          sizes="100vw"
        />
        <div className="absolute inset-0 bg-black/50"></div>
      </div>
    </section>
  );
};